module.exports = __webpack_public_path__ + "media/images/countrysquared/nf-1746757dc3792b364d64836d28100b8e.svg";